import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import { useSelector } from "react-redux";
import config from '../../config';
import { useNavigate } from "react-router-dom";
import { IoWarningOutline } from "react-icons/io5";

const AddCashTransaction = () => {
    const navigate = useNavigate();
    const companyId = useSelector((state) => state.user.companyId);

    const [baskets, setBaskets] = useState([])
    const [clients, setClients] = useState([])
    const [filteredClients, setFilteredClients] = useState([])
    const [showClientDropdown, setShowClientDropdown] = useState(false)
    const [clientSearchTerm, setClientSearchTerm] = useState("")
    const [categories, setCategories] = useState([])
    const [transactions, setTransactions] = useState([])
    const [err, setErr] = useState("")
    const [validationErrors, setValidationErrors] = useState({})

    // Check if form is valid for submission
    const isFormValid = () => {
        return (
            inputs.basketId && inputs.basketId !== "" && inputs.basketId !== "-" &&
            inputs.clientId && inputs.clientId !== "" && inputs.clientId !== "-" &&
            inputs.categoryId && inputs.categoryId !== "" && inputs.categoryId !== "-" &&
            inputs.updatedOn && inputs.updatedOn !== "" &&
            inputs.amount && inputs.amount !== "" && parseFloat(inputs.amount) > 0 &&
            inputs.comment && inputs.comment.trim() !== ""
        );
    }

    const [inputs, setInputs] = useState({
        leadgerId: "",
        comment: "",
        clientName: "",
        category: "",
        clientCode: "",
        categoryId: "",
        updatedOn: "",
        clientId: "",
        companyId: "",
        basketName: "",
        basketId: "",
        amount: "",
        transactionType: "",
        transactionTypeId: "",
    })

    useEffect(() => {        
        getBaskets()
        getCategories()        
        getTransactionTypes()
        
        // Add click outside listener to close dropdown
        const handleClickOutside = (event) => {
            if (!event.target.closest('.client-search-container')) {
                setShowClientDropdown(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    const getBaskets = async (e) => {
        try {
            const res = await axios.get(config.BL_API_URL + "/basket/v1/getBasketByCompanyId", { params: { companyId } });

            if (res.data)
            setBaskets(res.data) 
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const getCategories = async (e) => {
        try {
            const res = await axios.get(config.BL_API_URL+"/CashLedger/v1/getCashTransactionCategories");

            if (res.data)
            setCategories(res.data) 
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const getTransactionTypes = async (e) => {
        try {
            const res = await axios.get(config.BL_API_URL+"/CashLedger/v1/getTransactionTypes");

            if (res.data)
            setTransactions(res.data) 
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const getClients = async (e) => {
        try {
            const res = await axios.get(config.BL_API_URL+"/BasketClientMap/v1/getBasketSubscriber", {params: {basketId: e}});

            if (res.data) {
                setClients(res.data);
                setFilteredClients(res.data);
            } else {
                setErr("backend error");
            }

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const handleAddTransaction = async (e) => {
        e.preventDefault();
        
        // Validate form before submission
        const errors = {};
        
        if (!inputs.basketId || inputs.basketId === "" || inputs.basketId === "-") {
            errors.basketId = "Please select a basket";
        }
        
        if (!inputs.clientId || inputs.clientId === "" || inputs.clientId === "-") {
            errors.clientId = "Please select a client";
        }
        
        if (!inputs.categoryId || inputs.categoryId === "" || inputs.categoryId === "-") {
            errors.categoryId = "Please select a category";
        }
        
        if (!inputs.updatedOn || inputs.updatedOn === "") {
            errors.updatedOn = "Please select a transaction date";
        }
        
        if (!inputs.amount || inputs.amount === "" || parseFloat(inputs.amount) <= 0) {
            errors.amount = "Please enter a valid amount greater than 0";
        }
        
        if (!inputs.comment || inputs.comment.trim() === "") {
            errors.comment = "Please enter a comment";
        }
        
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            setErr("Please fill in all required fields");
            return;
        }
        
        setValidationErrors({});
        inputs.companyId = companyId;
        
        try {
            const jsonString = JSON.stringify(inputs);
            
            const res = await axios.post(config.BL_API_URL+"/CashLedger/v1/addCashLedgerTransaction", inputs);

            if (res.status === 200)
            {
                navigate("/cashregister");
                //window.location.href = "/cashregister";
            }
            else
                setErr(res.data.message || "backend error");

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const handleChange = (e) => {
        // Clear validation error for the field being changed
        if (validationErrors[e.target.name] || validationErrors[e.target.id]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[e.target.name];
                delete newErrors[e.target.id];
                return newErrors;
            });
        }
        
        if(e.target.name === "updatedOn" || e.target.name === "comment"){
            setInputs(prev => ({ ...prev, [e.target.name]: e.target.value,  [e.target.id]: e.target.value}))
        }
        else{
            setInputs(prev => ({ ...prev, [e.target.name]: e.target.value,  [e.target.id]: Number(e.target.value)}))
        }

        if(e.target.name === "basketName"){
            getClients(e.target.value);
            // Reset client selection when basket changes
            setClientSearchTerm("");
            setInputs(prev => ({ ...prev, clientName: "", clientId: "" }));
        }
        if(e.target.name === "category"){
            categories.map((category) => {
                if(category.id == e.target.value){
                    const myElement = document.getElementById("transactionTypeId");
                    myElement.value = category.cashTransactionType.id;
                    setInputs(prev => ({ ...prev, transactionType: category.cashTransactionType.name, transactionTypeId: category.cashTransactionType.id}));
                }
            });
            
        }
            
    }

    const handleClientSearch = (e) => {
        const searchTerm = e.target.value;
        setClientSearchTerm(searchTerm);
        
        if (searchTerm.length > 0) {
            const filtered = clients.filter(client => 
                client.clientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                client.clientCode.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredClients(filtered);
            setShowClientDropdown(true);
        } else {
            setFilteredClients(clients);
            setShowClientDropdown(false);
        }
    }

    const selectClient = (client) => {
        setClientSearchTerm(client.clientName);
        setInputs(prev => ({ 
            ...prev, 
            clientName: client.clientName, 
            clientId: client.clientId,
            clientCode: client.clientCode 
        }));
        setShowClientDropdown(false);
        
        // Clear client validation error when client is selected
        if (validationErrors.clientId) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.clientId;
                return newErrors;
            });
        }
    }

    return (
        <div>
            <div className="my-14 md:px-14 max-w-screen-2xl mx-auto ">
                <div className="max-w-4xl px-4 sm:px-6 lg:px-8 lg:py-2 mx-auto">
                    <div className="bg-formbackground rounded-xl shadow p-4 sm:p-7 ">
                        <div className="mb-8">
                            <h2 className="text-xl font-bold text-gray-800 ">
                                Add New Cash Transaction 
                            </h2>
                            <p><span><IoWarningOutline /></span> Warning!! Adding cash transaction of category Investment, additional investment
                            would generate buy orders and adding System Charges or any withdraw category would generate sell orders if there is no sufficient cash, so use carefully!</p>
                        </div>
                        <form>
                            <div className="grid sm:grid-cols-12 gap-2 sm:gap-6">

                                {/* Basket Name ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="basketName" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span >Basket Name </span>
                                    </label>
                                </div>
                                <div className="sm:col-span-4">
                                    <div className="sm:flex">
                                    <select
                                        onChange={handleChange}
                                        name="basketName" id="basketId"
                                        className={`py-2 px-3 pe-9 block min-w-full w-full sm:w-auto shadow-sm -mt-px -ms-px rounded-lg text-sm relative focus:z-10 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ${
                                            validationErrors.basketId ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-blue-500'
                                        }`}>
                                        <option value="-">- Select -</option>
                                        {baskets && (
                                            baskets.map((basket, index) => <option key={index} value={basket.basketId}>{basket.name}</option>)
                                        )}
                                    </select>
                                    {validationErrors.basketId && (
                                        <div className="text-red-500 text-xs mt-1">{validationErrors.basketId}</div>
                                    )}
                                    </div>
                                </div>
                                {/* clients Name ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="clientName" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span >Client Name</span>
                                    </label>
                                </div>
                                <div className="sm:col-span-4">
                                    <div className="relative client-search-container">
                                        <input
                                            type="text"
                                            value={clientSearchTerm}
                                            onChange={handleClientSearch}
                                            onFocus={() => setShowClientDropdown(clientSearchTerm.length > 0)}
                                            placeholder="Search client by name or code..."
                                            className={`py-2 px-3 block w-full shadow-sm rounded-lg text-sm focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ${
                                                validationErrors.clientId ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-blue-500'
                                            }`}
                                            disabled={!clients.length}
                                        />
                                        {!clients.length && (
                                            <div className="text-xs text-gray-500 mt-1">Please select a basket first</div>
                                        )}
                                        {validationErrors.clientId && (
                                            <div className="text-red-500 text-xs mt-1">{validationErrors.clientId}</div>
                                        )}
                                        {showClientDropdown && filteredClients.length > 0 && (
                                            <div className="absolute z-10 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto mt-1">
                                                {filteredClients.map((client, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => selectClient(client)}
                                                        className="px-3 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                                                    >
                                                        <div className="text-sm font-medium text-gray-900">{client.clientName}</div>
                                                        <div className="text-xs text-gray-500">Code: {client.clientCode}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {showClientDropdown && filteredClients.length === 0 && clientSearchTerm.length > 0 && (
                                            <div className="absolute z-10 w-full bg-white border border-gray-200 rounded-lg shadow-lg mt-1">
                                                <div className="px-3 py-2 text-sm text-gray-500 text-center">
                                                    No clients found matching "{clientSearchTerm}"
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>


                                {/* Category ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="category" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span>Category</span>
                                    </label>
                                </div>
                                <div className="sm:col-span-4">
                                    <div className="sm:flex">
                                        <select
                                            onChange={handleChange}
                                            name="category" id="categoryId"
                                            className={`py-2 px-3 pe-9 block min-w-full w-full sm:w-auto shadow-sm -mt-px -ms-px rounded-lg text-sm relative focus:z-10 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ${
                                                validationErrors.categoryId ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-blue-500'
                                            }`}>
                                            <option value="-">- Select -</option>
                                            {categories && (
                                                categories.map((category, index) => <option key={index} value={category.id}>{category.name}</option>)
                                            )}
                                        </select>
                                        {validationErrors.categoryId && (
                                            <div className="text-red-500 text-xs mt-1">{validationErrors.categoryId}</div>
                                        )}
                                    </div>
                                </div>
                                {/* date from ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="addedOn" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span >Transaction Date</span>
                                    </label>
                                </div>
                                <div className="sm:col-span-4">
                                    <div className="sm:flex">
                                        <input
                                            onChange={handleChange}
                                            type="date" name="updatedOn" id="updatedOn" placeholder=""
                                            className={`py-2 px-3 pe-11 block w-full shadow-sm text-sm rounded-lg focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ${
                                                validationErrors.updatedOn ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-blue-500'
                                            }`} />
                                        {validationErrors.updatedOn && (
                                            <div className="text-red-500 text-xs mt-1">{validationErrors.updatedOn}</div>
                                        )}
                                    </div>
                                </div>


                                {/* Type ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="transactionType" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span >Transaction Type</span>
                                    </label>
                                </div>
                                <div className="sm:col-span-4 min-w-full">

                                    <select disabled="true"
                                        onChange={handleChange}
                                        name="transactionType" id="transactionTypeId"
                                        className="py-2 px-3 pe-9 block min-w-full w-full sm:w-auto border-gray-200 shadow-sm -mt-px -ms-px rounded-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ">
                                        <option value="-">- Select -</option>
                                        {transactions && (
                                            transactions.map((transaction, index) => <option key={index} value={transaction.id}>{transaction.name}</option>)
                                        )}
                                    </select>

                                </div>

                                {/* Amount ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="amount" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span > Amount</span>
                                    </label>
                                </div>
                                <div className="sm:col-span-4">
                                    <div className="sm:flex">
                                        <input
                                            onChange={handleChange}
                                            type="number" name="amount" id="amount" placeholder=""
                                            className={`py-2 px-3 pe-11 block w-full shadow-sm text-sm rounded-lg focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ${
                                                validationErrors.amount ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-blue-500'
                                            }`} />
                                        {validationErrors.amount && (
                                            <div className="text-red-500 text-xs mt-1">{validationErrors.amount}</div>
                                        )}
                                    </div>
                                </div>



                                {/* comment ---- */}
                                <div className="sm:col-span-2">
                                    <label htmlFor="comment" className="inline-block text-sm text-gray-800 mt-2.5">
                                        <span >Comment</span>
                                    </label>
                                </div>
                                <div className="sm:col-span-10">
                                    <input
                                        onChange={handleChange}
                                        name="comment" id="comment"
                                        className={`py-2 px-3 block w-full shadow-sm rounded-lg text-sm focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ${
                                            validationErrors.comment ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-blue-500'
                                        }`} />
                                    {validationErrors.comment && (
                                        <div className="text-red-500 text-xs mt-1">{validationErrors.comment}</div>
                                    )}
                                </div>

                                {/* Files ---- */}
                                <div className="sm:col-span-2">                                   
                                </div>                                
                            </div>


                            <div className="flex justify-end gap-x-2 mt-2">

                                <Link to="/cashregister" type="button" className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none ">
                                    Cancel
                                </Link>
                                <button 
                                    type="button" 
                                    onClick={handleAddTransaction} 
                                    disabled={!isFormValid()}
                                    className={`py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-white ${
                                        isFormValid() 
                                            ? 'bg-blue-600 hover:bg-blue-700 cursor-pointer' 
                                            : 'bg-gray-400 cursor-not-allowed'
                                    } disabled:opacity-50 disabled:pointer-events-none`}>
                                    Save changes
                                </button>
                            </div>
                            <p className="text-red-400 mt-8">
                                {err}
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default AddCashTransaction;